export const PortfolioSubCategories = {
  Equity: ["Sector", "Holding", "Asset", "Market Cap"], // For MF
  Debt: ["Sector", "Holding", "Asset", "Ratings"], // For MF
  Hybrid: ["Holding", "Asset", "Market Cap", "Ratings"], // For MF
  Others: ["Sector", "Holding", "Asset"], // For MF
  Other: ["Sector", "Holding", "Asset"], // For MF
  IndexAndETF: ["Sector", "Holding", "Asset", "Market Cap"], // For IndexAndETF
};
export const chartColors = [
  "#49AEE2",
  "#F9AA67",
  "#BD4B9B",
  "#66D1AC",
  "#363359",
  "#CCCCD6",
];

export enum IcategoryTypes {
  EQUITY = "Equity",
  DEBT = "Debt",
  HYBRID = "Hybrid",
  OTHERS = "Others",
}
export enum PortfolioCategory {
  Sector = "Sector",
  Holding = "Holding",
  Asset = "Asset",
  MarketCap = "Market Cap",
  Rating = "Ratings",
}
